import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { finalize } from 'rxjs';
import { map } from 'rxjs/operators';
import { TreeNode, TreeTableNode } from 'primeng/api';

import { DeviceManagerService } from '../../../core/services/device-manager.service';
import { Folder } from '../../../api/folders/folder.model';
import { FolderManagerService } from '../../../api/folders/folder-manager.service';
import { PdfAsset } from '../../../api/pdfs/pdf-asset-model';

@Component({
	selector: 'mycampapp-select-document-pdf',
	templateUrl: './select-document-pdf.component.html',
	styleUrls: ['./select-document-pdf.component.less']
})
export class SelectDocumentPdfComponent implements OnInit
{
	@Output() pdfSelected = new EventEmitter<PdfAsset>();

	loading = false;
	foldersTree: TreeNode[] = [];
	selectedNode?: TreeTableNode<any> | TreeTableNode<any>[] | null;
	visible = true;

	constructor(public deviceManager: DeviceManagerService,
	            private folderManager: FolderManagerService) { }

	ngOnInit(): void
	{
		this.loadFolder();
	}

	isFolderNode(treeNode: TreeNode): boolean { return treeNode.data instanceof Folder; }
	isPdfNode(treeNode: TreeTableNode<any> | TreeTableNode<any>[] | null): boolean {
		return treeNode == null || Array.isArray(treeNode) ? false : treeNode.data instanceof PdfAsset; }

	onFolderExpanded(treeNode: TreeNode): void
	{
		if (treeNode.children!.length === 0 || treeNode.children![0].data !== undefined) return;

		treeNode.children = [];
		this.loadFolder(treeNode);
	}

	onHide()
	{
		this.pdfSelected.emit(undefined);
	}

	onOk()
	{
		this.pdfSelected.emit((<TreeTableNode>this.selectedNode!).data);
	}

	private loadFolder(treeNode?: TreeNode): void
	{
		this.loading = true;
		this.folderManager.getFolder(treeNode === undefined ? 0 : treeNode.data.Id).pipe(finalize(() => this.loading = false), map((folder: Folder) =>
		{
			const nodes = folder.Folders.map(subFolder => this.createTreeNodeFromFolder(subFolder)).concat(this.createPdfTreeNodes(folder.Pdfs));
			if (treeNode === undefined)
			{
				this.foldersTree = nodes;
			} else {
				treeNode.data = folder;
				treeNode.children = nodes;
			}
			return true;
		})).subscribe();
	}

	private createTreeNodeFromFolder(folder: Folder): TreeNode
	{
		let children = !folder.HasSubFolders ? [] :
			folder.Folders.length === 0 ? [this.emptyFolderTreeNode] : folder.Folders.map(f => this.createTreeNodeFromFolder(f));
		children = children.concat(this.createPdfTreeNodes(folder.Pdfs));
		return {
			data: folder,
			label: folder.Name,
			expanded: false,
			children: children,
			leaf: !folder.HasSubFolders,
			draggable: false,
			styleClass: 'full-line-tree-node'
		};
	}

	private createPdfTreeNodes(pdfs: PdfAsset[]): TreeNode[]
	{
		return pdfs.map(pdf => <TreeNode> {
			data: pdf,
			label: pdf.simpleName,
			leaf: true,
			draggable: true,
			styleClass: 'full-line-tree-node'
		});
	}

	private get emptyFolderTreeNode(): TreeNode
	{
		return { data: undefined };
	}
}
